import kumir from "refractor/kumir";
export default kumir;